import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import HotelOrder from "@com/order/HotelOrder.vue";
export default {
  __name: 'HotelOrder',

  setup(__props) {
    return (_ctx, _cache) => {
      const _component_el_main = _resolveComponent("el-main");

      return _openBlock(), _createElementBlock("div", null, [_createVNode(_component_el_main, {
        class: "base_main_content"
      }, {
        default: _withCtx(() => [_createVNode(HotelOrder, {
          type: "order",
          routeName: "hotelorder"
        })]),
        _: 1
      })]);
    };
  }

};